export const EVENT_HEADER_IMAGE_WIDTH = '700'
export const EVENT_HEADER_IMAGE_HEIGHT = '367'
export const EVENT_CARD_IMAGE_WIDTH = '400'
export const EVENT_CARD_IMAGE_HEIGHT = '205'

export const BREAKPOINTS = {
  xxs: 330,
  xs: 480,
  sm: 576,
  md: 768,
  lg: 922,
  xl: 1200,
}
